import ReactRenderer from 'modules/_react-renderer'

import 'widgets/mtt-ttmzero-cover'
import 'widgets/mtt-ttmzero-circle'
import 'widgets/mtt-ttmzero-greeks-risk'

ReactRenderer.render()
